import { memo, useState } from 'react';
import { styled, Box } from '@mui/material';

import Avatar from 'app/components/Avatar';
import Icon from 'app/components/Icon';

import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import PhotoViewer from 'app/views/profile/components/PhotoViewer';
import PhotoUploader from 'app/views/dashboard/components/PhotoUploader';
import { updateUser, updateProfile } from 'app/redux/actions/AuthActions';

const SidebarBox = styled(Box)(({mode, bg, sml }) => ({
    '& .background': {
        backgroundImage:`url(${bg})`, display: !sml ? "block" : "none",
        ":before": { backgroundImage: bg ? 'linear-gradient( 3deg, rgb(0,0,0) 0%, rgba(0,0,0,0.64) 20%, rgba(0,0,0,0.55) 30%, rgba(128,128,128,0.17) 50%, rgba(255,255,255,0) 100%)' : "none" }
    },
    '& .content':{ 
        '& .photo': { 
            marginTop: sml ? "15px" : 0, marginBottom: sml ? 0 : "10px",
            transition: `all ${["full","mobile"].includes(mode) ? 350 :200}ms ease-in`
        },
        '& b,a': { display: sml ? "none" : "inhert" }
    },
    '& .upload': { display: sml ? "none" : "flex" },
    '& .go_live': { borderRadius:'3px', padding:'6px 10px', fontSize: '13.5px', lineHeight:'16px', backgroundColor:"#d00", border:"1px solid #c00", color:'#FFF', marginTop:'10px', cursor:'pointer' }
}));

const SidebarTop = ({ source, mode, hover }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = useSelector((store) => store.auth.user || {});
    
    const [photoViewer,setPhotoViewer] = useState(null);

    const onNavigate = (e) =>{
        if( e ) e.preventDefault();
        navigate(`/user/${data?.username}`,{state: data});
    }

    if( !data?.username )
        return null;

    const onView = () =>{
        if( source !== 'dashboard' || !data?.image ) return false;
        setPhotoViewer(data.image);
    }

    var size = (hover || ["full","mobile"].includes(mode) ? 110 : 45);
    return <>
        {data?.ID && source === 'dashboard' && photoViewer && <PhotoViewer 
            src={photoViewer} 
            me={true} 
            userId={data.ID} 
            onClose={()=>setPhotoViewer(null)} 
            onSetMain={res=>dispatch(updateUser({image: res?.image}))}
        />}
        
        <SidebarBox className="sidebar_box" mode={mode} sml={hover || ["full","mobile"].includes(mode) ? 0 : 1} bg={data?.profile?.background || ''}>
            <div className="background">
                <PhotoUploader
                    title="Cover"
                    icon="camera-retro" 
                    width={1300}
                    height={350}
                    crop={true}
                    url="user/update/cover"
                    onSuccess={res=>dispatch(updateProfile({background: res.background}))}
                    button={props=><Icon className="upload rt" {...props}>camera-retro</Icon>}
                />
            </div>
            <div className="content">
                <div className="photo" style={{ width: size+4, height: size+4  }}>
                    <Avatar sx={{ width:"100%", cursor:data?.image && source==='dashboard'?'pointer':'text', height:"100%", borderRadius:"50%", fontSize:((size/45*15)+5), transition: 'all 220ms ease-in' }} name={`${data.firstname} ${data.lastname}`} src={data.image} onClick={()=>onView()} />
                    <PhotoUploader 
                        title="Photo"
                        icon="camera"
                        crop={true}
                        camera={true}
                        url="user/update/photo"
                        onSuccess={res=>dispatch(updateUser({image: res.image}))}
                        button={props=><Icon className="upload lf" {...props}>camera</Icon>}
                    />
                </div>
                <b>{data.firstname} {data.lastname}</b>
                <a href={`/user/${data.username}`} onClick={(e)=>onNavigate(e)}>@{data.username}</a>

                <button onClick={()=>navigate(`/dashboard/livestream`)} className="go_live"><Icon>video</Icon>{size === 110 && ' Go Live'}</button>
        
            </div>
        </SidebarBox>
    </>;
}

export default memo(SidebarTop);